import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Назад',
      changePassword: 'Зміна',
      copiedVaultId: 'Готово!',
      copyVaultID: 'Скопіювати Vault ID',
      create: 'Створити',
      next: 'Далі',
      notSure: 'Я не впевнений(а)',
      signUp: 'Зареєструватися',
      submit: 'Надіслати',
      updatePassword: 'Оновити пароль',
    },
    Errors: {
      createReportFailed: 'Не вдалося створити звіт.',
    },
    ReportStatus: {
      CLOSED: 'Закрито',
      INVESTIGATING: 'Розслідування',
      NEW: 'Надіслано',
      READ: 'Прочитано',
    },
    general: {
      navbar: {
        caseSettings: 'Налаштування справи',
        changePassword: 'Змінити пароль',
        logOut: 'Вийти',
        notifications: 'Сповіщення',
        notificationsDrawer: {
          appFileScanFailed: 'Файл не пройшов перевірку безпеки',
          appReportMatch: 'Ваш запис GoTogether був зіставлений',
          appReportReassigned: 'Новий менеджер з кейсів був призначений',
          case: 'Справа',
          caseAssigned: 'Справу призначено вам',
          caseImporterJobCompleted: {
            PartialSuccess: 'Ваш імпорт справ завершився з помилками',
            failure: 'Ваш випадок імпорту не вдався',
            success: 'Ваш випадок імпорту успішно завершено',
          },
          caseLinked: "Випадок пов'язаний",
          caseTeamInvite: 'Додано до справи',
          caseUnlinked: "Справа не пов'язана",
          dataSanitisation: 'Деталі звіту оновлено',
          emptyDescription: 'Перевірте пізніше на наявність нових сповіщень',
          emptyTitle: 'Ви зробили все, що потрібно',
          importId: 'Імпортуйте ID:',
          learnMore: 'Дізнатися більше',
          markAllAsRead: 'Позначити все як прочитане',
          newMessage: 'Нове повідомлення',
          newReport: 'Новий звіт отримано',
          permissionRemoved: 'Видалено з справи',
          postSSubmissionFile: 'Додано файл(и) доказів',
          report: 'Звіт',
          reportAssigned: 'Звіт призначений вам',
          reportStatusChange: 'Статус звіту змінено',
          reporterAnonymised: 'Ваші деталі були анонімізовані',
          reporterReportSubmitted: {
            subtitle: 'Ми рекомендуємо зберегти копію вашого звіту',
            title: 'Звіт подано',
          },
          mitigationPlanReminder: "Необхідне затвердження плану пом'якшення",
          staleCase: 'Невиконаний випадок',
        },
        privacyStatement: 'Заява про конфіденційність',
        reporter: {
          myReports: 'Мої звіти',
        },
        settings: 'Налаштування',
        technicalSupport: 'Технічна підтримка',
        title: 'Обліковий запис',
      },
      time: {
        day: 'День',
        days: 'Дні',
        hour: 'Година',
        hours: 'Години',
        minute: 'Хвилина',
        minutes: 'Хвилини',
        second: 'Секунда',
        seconds: 'Секунди',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Анонімний',
        autoTranslate: 'Автоматичний переклад вимкнений за замовчуванням.',
        backToMessages: 'Повернутися до повідомлень',
        caseSettings: 'Налаштування справи.',
        changeInProfile:
          'Якщо ви бажаєте змінити цей параметр, ви можете зробити це у своєму профілі',
        deletedByMessage: 'Видалено {{author}}',
        deletedMessageLabel: 'Це повідомлення було видалено',
        description:
          'Коли увімкнено автоматичний переклад, всі повідомлення звіту будуть\n          автоматично перекладені за допомогою AI на основі мови за замовчуванням,\n          вибраної у вашому браузері.',
        descriptionSecondHalf:
          'Оригінальна версія всіх повідомлень завжди зберігається і може бути знайдена в чаті.',
        messagePlaceholder: 'Почніть друкувати...',
        messageSettings: 'Налаштування повідомлень.',
        originalMessages: 'Original',
        showMoreBanner: 'Дізнайтеся більше про автоматичні переклади',
        titlev2: 'Читайте всі повідомлення на вашій улюбленій мові.',
        translatedMessageLabel: 'Перекладене повідомлення',
        translatedMessages: 'Перекладено',
        understood: 'Зрозуміло',
      },
      Country: {
        description: 'У якій країні ви працюєте?',
        header: 'У якій країні ви працюєте?',
        noOptions: 'Країни не знайдено',
        other: 'Інше',
        placeholder: 'Пошук країни...',
      },
      CreatePublicReport: {
        createReport: 'Створити звіт',
        helpPage: 'Перейти на сторінку довідки',
        loginToOpr: 'Увійти, щоб відстежувати звіти',
        or: 'або',
        passwordPlaceholder: 'Введіть пароль',
        phoneNumberLoginFailed:
          'Не вдалося увійти: номер телефону/пін-код недійсний',
        phoneNumberPlaceholder: 'Введіть свій номер телефону',
        phoneNumberTooltip:
          "Введіть номер телефону, який ви використовували для зв'язку з VaultTalk",
        pinPlaceholder: 'Введіть пін-код',
        reportIntroductionParagraph1:
          'Коли ви повідомляєте про інцидент, вам буде поставлено кілька запитань, які допоможуть задокументувати ваш досвід.',
        reportIntroductionParagraph2:
          'Надсилаючи звіт, ви можете залишитись анонімним, щоб захистити свою конфіденційність.',
        reportIntroductionParagraph3:
          'Після того, як ви надішлете звіт, ви можете увійти в систему в будь-який час, щоб побачити прогрес вашого звіту й поспілкуватися з куратором.',
        reportIssue: 'Повідомити про проблему',
        usernameLoginFailed: "Помилка входу: недійсне ім'я користувача/пароль",
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              "Відносини з компанією є обов'язковими",
            reportedCategoryRequired: "Повідомлена категорія є обов'язковою",
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Введіть свою електронну адресу або Vault ID',
        vaultIdTooltip:
          'Для анонімних повідомлень Vault ID є буквено-цифровим. Якщо повідомлення не було анонімним, ID Vault — це ваша електронна адреса',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ваш пароль',
        yourPhoneNumber: 'Ваш номер телефону',
        yourPin: 'Ваш 6-значний пін-код',
        yourVaultId: 'Ваш Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Логотип {{company}}',
        openReporting: 'Відкрита звітність',
        userSettings: 'Налаштування користувача',
      },
      Date: {
        approximateDescription:
          "Чи пам'ятаєте ви приблизну дату, коли стався цей випадок?",
        approximatePlaceholder:
          'Наприклад: 6 місяців тому / минулого року / листопад минулого року',
        cancel: 'скасувати',
        clear: 'зрозуміло',
        description: "Чи пам'ятаєте ви дату, коли стався цей випадок?",
        header: 'В який день це сталося?',
        ok: 'гаразд',
        placeholder: 'Наприклад: 21 червня 2020 року',
      },
      Description: {
        whatHappened: 'Що сталося?',
        whatHappenedPlaceholder: 'Опишіть своїми словами...',
        whatHappenedText: 'Опишіть своїми словами, що сталося',
      },
      Details: {
        disclaimer:
          'Ці дані будуть опубліковані разом з вашим звітом. Якщо ви бажаєте зберегти анонімність, переконайтеся, що вони не містять інформації, яка може вас ідентифікувати.',
        emailPlaceholder: "Електронна пошта (необов'язково)",
        fullNamePlaceholder: "Повне ім'я (необов'язково)",
        header: 'Ваші дані',
        nonAnonSubtitle:
          "Будь ласка, надайте або своє ім'я, або адресу електронної пошти. Якщо ви хочете отримувати сповіщення про цей звіт, додайте відповідну адресу електронної пошти нижче.",
        nonOptionalEmailPlaceholder: 'Електронна пошта',
        nonOptionalFullNamePlaceholder: "Повне Ім'я",
        subtitle:
          'Якщо ви хочете отримувати сповіщення про цей звіт, додайте відповідну електронну адресу нижче.',
      },
      Emotion: {
        description: 'Як ви почувалися? На що це вплинуло?',
        header: 'На що це вплинуло?',
        placeholder: 'Почніть друкувати...',
      },
      Evidence: {
        addedHeading: 'Додано',
        deletedMessage: 'було видалено',
        deletedStatus: 'Видалено',
        failedToOpenFileMessage: 'Не вдалося відкрити файл. Спробуйте ще раз',
        fileStatuses: {
          infectedUpload: 'Позначено під час перевірки безпеки',
          passedUpload: 'Перевірку безпеки пройдено',
          pendingUpload: 'Триває перевірка безпеки',
          readyForDownload: 'Готово до завантаження',
        },
        mobileErrorMessage: 'Позначені файли: повідомте свого куратора',
        nameHeading: "Ім'я",
        statusHeading: 'Статус',
        tableTitle: 'Докази',
        webErrorMessage:
          'Позначені файли: Якщо файл(и) було позначено, будь ласка, повідомте куратора',
      },
      FileUpload: {
        addFiles: 'Додати файли',
        addMoreFiles: 'Додати більше файлів',
        confirm: 'Підтвердити',
        description:
          "Додавання файлів як доказів може допомогти вашому куратору ефективно розв'язати справу. Ознайомтеся зі змістом файлу (в тому числі з метаданими), якщо ви бажаєте зберегти анонімність і поважаєте права інших осіб та чинне законодавство.",
        dragDrop: 'Перетягніть файли сюди або',
        errorMessage:
          'Не вдалося завантажити файл(и) через помилку мережі. Натисніть нижче, щоб звернутися за допомогою до куратора',
        fileLimit: 'Обмеження розміру кожного файлу: 100 МБ',
        fileUploadLimitText: 'Можна завантажити лише 10 файлів',
        header: 'Додайте докази',
        helpArticle: 'стаття довідки',
        highlighted: 'вибрати файли',
        information: 'Підтримувані типи файлів',
        moreInformation:
          'Для отримання додаткової інформації див. <a>стаття довідки</a>',
        postSubmissionErrorMessage:
          'Не вдалося завантажити файли через помилку системи. Натисніть «підтвердити» ще раз.',
        tooltipAudio: 'Аудіофайли:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Документи:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Зображення:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Текстові файли:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Відеофайли:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Файл занадто великий',
          invalidFileType: 'Непідтримуваний тип файлу: {{extension}}',
          systemError: 'Помилка системи',
          tooManyFiles: 'Максимальна кількість файлів — {{maxFiles}}',
        },
        uploadFiles: 'Завантажити файли',
      },
      Loading: {
        loading: 'Зачекайте, поки ми передамо ваш звіт куратору...',
        postSubmissionLoading: 'Зачекайте, поки ми надішлемо ваші файли...',
      },
      Location: {
        description: 'Де це сталося?',
        header: 'Де це сталося?',
        placeholder: 'Наприклад: в офісі',
      },
      MessageListBox: {
        messageCaseManager: 'Повідомлення куратора',
        report: 'Звіт {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Переклад вимкнено',
        enableTranslationLabelEnabled: 'Переклад увімкнено',
        enableTranslationsDescription:
          'Увімкніть автоматичний переклад і читайте всі повідомлення звіту на вашій бажаній мові. Мова перекладу базується на мові, вибраній на вашому пристрої.',
        enableTranslationsHeader:
          'Увімкнути автоматичний переклад для повідомлень звіту',
        enableTranslationsSubDescriptionv2:
          'Ви можете перемикатися між перекладеною та оригінальною мовою в кожному чаті.',
        updateTranslationFailed: 'Оновлення перекладу не вдалося',
        updateTranslationSuccess: 'Налаштування перекладу успішно оновлено',
      },
      Password: {
        changePasswordHeader: 'Змінити',
        createNewPassword: 'Створіть новий пароль',
        createPasswordHeader: 'Ваш пароль',
        currentPasswordPlaceholder: 'Введіть поточний пароль',
        description:
          'Дійсний пароль повинен мати щонайменше 9 символів і містити одну велику літеру та одну цифру',
        enterCurrentPassword: 'Введіть свій поточний пароль',
        forgottenPasswordInstructions:
          'Введіть свій альфанумеричний ІД Vault (не вашу електронну адресу) та електронну адресу для скидання вашого пароля.',
        newDescription:
          'Створіть надійний пароль, щоб забезпечити безпеку вашого облікового запису. Почніть вводити текст, щоб побачити рекомендації нижче.',
        passwordPlaceholder: 'Створіть пароль',
        passwordResetRequestedDescription:
          'Якщо ваш Vault ID існує в нашій системі, ви отримаєте електронний лист з інструкціями для скидання вашого пароля.',
        passwordResetRequestedHeader: 'Посилання для скидання паролю запитано',
        reenterPlaceholder: 'Введіть пароль ще раз',
        subtitle:
          'Створіть пароль, щоб надіслати цей звіт і мати доступ до нього в майбутньому',
        yourVaultId: 'Ваш Vault ID',
        yourVaultIdPlaceholder:
          'Введіть свій ID Vault (наприклад, {{exampleId}})',
      },
      Perpetrators: {
        description:
          'У повідомленні йдеться про конкретну особу чи кількох людей? Можете назвати або описати їх?',
        header: 'Учасники',
        placeholder:
          'Почніть вводити й використовуйте кому, щоб додати кілька імен або описів',
      },
      PoweredByVault: 'За підтримки {{company}}',
      PrivacyStatement: 'Заява про конфіденційність',
      PublicMessageList: {
        myMessages: 'Мої повідомлення',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'До наявного звіту додано докази',
        backToReportId: 'Повернутися до звіту: {{reportId}}',
        description:
          "Додавання файлів як доказів може допомогти вашому куратору ефективно розв'язати справу. Ознайомтеся зі змістом файлу (в тому числі з метаданими), якщо ви бажаєте зберегти анонімність і поважаєте права інших осіб та чинне законодавство. Для отримання додаткової інформації див. <a>стаття довідки</a>",
        header: 'Додайте додаткові докази до звіту',
        vaultTalkOpenCaseHeader: 'Додайте докази до звіту',
      },
      PublicReport: {
        anonymous: 'Анонімно',
        backToReports: 'Повернутися до звітів',
        skipped: 'Пропущено',
      },
      PublicReportCard: {
        addEvidence: 'Додати додаткові докази',
        messageCaseManager: 'Повідомлення куратору',
        reportId: 'ID звіту:',
        submitted: 'Надіслано',
        vaultTalkClosedCaseCTA: 'Переглянути докази',
        vaultTalkOpenCaseCTA: 'Додати докази',
        viewAdditionalEvidence: 'Переглянути додаткові докази',
        viewReport: 'Переглянути звіт',
      },
      PublicReportsList: {
        reportingSystem: 'Система звітності',
      },
      Question: {
        placeholder: 'Почніть друкувати...',
        question: 'Надайте детальну інформацію',
        questionText:
          'Поділіться з нами своїми занепокоєннями, оновленнями або створіть запит',
      },
      Relationship: {
        header: "Ваш зв'язок з організацією",
        tellUsAbout: 'Укажіть, яке відношення ви маєте до організації.',
      },
      ResponsiveNavMenu: {
        messages: 'Мої повідомлення',
        reports: 'Мої звіти',
      },
      Site: {
        description: 'На якому об’єкті ви працюєте?',
        header: 'На якому об’єкті ви працюєте?',
        noOptions: 'Об’єктів не знайдено',
        other: 'Інше',
        placeholder: 'Пошук об’єкта...',
      },
      SpamPuzzle: {
        dialog: "Щоб продовжити, розв'яжіть цю головоломку",
      },
      SubmissionTypes: {
        reportIssue: 'Виберіть категорію',
        whatType: 'Виберіть категорію, яка найкраще описує ваш звіт',
      },
      SubmitSuccess: {
        category: '<bold>Категорія:</bold> {{category}}',
        country: '<bold>Країна:</bold> {{country}}',
        dateSubmitted: '<bold>Дата подання:</bold> {{date}}',
        recordYourVaultID: "Запам'ятайте ці дані для входу",
        successInformation: 'Більше інформації',
        successMessage:
          'Ваш звіт надіслано, і він готовий до розгляду. Будь-які прикріплені файли, які потребують уваги, будуть позначені при вході в систему. Увійдіть нижче, щоб переглянути оновлення звіту або надіслати повідомлення своєму куратору.',
        successSanitationMessage:
          'Збережіть копію для своїх записів і тримайте свій Vault-ID в безпеці - вам знадобиться для доступу до оновлень та повідомлень вашому менеджеру справ.',
        successSanitationTagline: 'Ваш звіт було подано та безпечно збережено.',
        successThankYou: 'Дякуємо за звіт!',
        viewReport: 'Переглянути звіт',
      },
      Time: {
        approximateDescription:
          "Чи пам'ятаєте ви приблизний час, коли стався цей випадок?",
        approximatePlaceholder: 'Наприклад: вранці, вдень',
        description: "Ви пам'ятаєте, коли стався цей випадок?",
        header: 'О котрій годині це сталося?',
        invalidTime: 'Формат часу має бути таким: ГГ:ХХ',
      },
      UserSettingsDialog: {
        changePassword: 'Змінити пароль',
        closeDialog: 'Закрити діалог',
        logout: 'Вийти',
        messageSettings: 'Налаштування повідомлень',
        userSettings: 'Налаштування користувача',
      },
      Witnesses: {
        description:
          'Чи ви комусь розповіли про те, що сталося, і чи був хтось інший свідком випадку, про який іде мова?',
        header: 'Чи були свідки?',
        placeholder: 'Почніть друкувати...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Надіслати повідомлення',
        title: 'Повідомлення Керуючий справами',
        translationHeader: 'Дізнайтеся більше про автоматичні переклади',
      },
      ReportCard: {
        addEvidence: 'Додати докази',
        submissionModeVia: 'через {{submissionMode}}',
        viewEvidence: 'Переглянути докази',
      },
      ReportList: {
        yourReports: 'Ваші звіти',
      },
      ReportingActivate: {
        buttonText: 'Продовжуйте',
        description:
          'Якщо ваша організація зареєструвала вас для облікового запису, ми надішлемо вам електронний лист з інструкціями для завершення налаштувань.',
        emailInput: 'Електронна пошта',
        header: 'Введіть свій робочий електронний лист',
        successAccount:
          'Якщо ваша організація зареєструвала вас для отримання облікового запису, ми надішлемо вам електронний лист з інструкціями для завершення налаштування.',
        successEmail:
          'Якщо ви не бачите його відразу, будь ласка, зачекайте кілька хвилин і оновіть свою поштову скриньку.',
        successHeading: 'Дякую',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Додайте докази до свого звіту',
        descriptionText:
          'Додавання файлів як доказів може допомогти підтримати ефективність вирішення вами вашого дела. Будь ласка, врахуйте вміст файлу (включаючи метадані файлу), якщо ви хочете залишитися анонімними, та поважайте права інших осіб та відповідні закони.  Для отримання додаткової інформації, будь ласка, дивіться цю <a>статтю допомоги</a>',
        emptyMessage: 'Не завантажено додаткових доказів',
      },
      ReportingChangePassword: {
        back: 'Назад',
        description:
          'Створіть надійний пароль, щоб зберегти безпеку свого акаунту. Почніть друкувати, щоб побачити рекомендації нижче.',
        errorToast: 'Не можу створити пароль, недійсний токен.',
        header: 'Змінити пароль',
        incorrectCurrentPassword:
          'Поточний пароль неправильний. Будь ласка, перевірте його та спробуйте ще раз.',
        invalidToken: 'Недійсний токен',
        passwordUpdated: 'Пароль оновлено',
        passwordUpdatedDescription:
          'Ваш пароль успішно оновлено. Дякуємо, що ви зробили цей крок, щоб зберегти ваші дані в безпеці!',
        passwordUsedBefore: 'Повторне використання паролю не дозволено',
        passwordUsedBeforeDescription:
          'Для вашої безпеки, ви не можете повторно використовувати жоден з шести останніх паролів. Будь ласка, виберіть новий, унікальний пароль, щоб забезпечити безпеку вашого облікового запису та спробуйте знову.',
        toastDescription:
          'Ваш пароль було успішно оновлено. Дякуємо, що ви вжили ці кроки, щоб зберегти безпеку своїх даних!',
        toastMessage: 'Пароль оновлено',
        updatePasswordCTA: 'Оновити пароль',
      },
      ReportingConnect: {
        cancelButton: 'Скасувати',
        connectButton: 'Підключити',
        disclaimer:
          "Підключення вашого Slack-акаунту до облікового запису Vault гарантує безпечне та приватне з'єднання.<br /><br />Підключившись, ви можете повідомити про недоречну поведінку або поставити питання безпосередньо в Slack. Ви завжди будете мати можливість анонімно звітувати після підключення. Вашою конфіденційностю та безпекою ми найбільше цінуємо.",
        heading:
          'Платформа Vault запитує дозвіл на доступ до вашого Slack-акаунту {{organisationName}}',
        listHeading: 'Що зможе робити Vault?',
        permissionIdentity: {
          extraInfo:
            'Vault матиме можливість переглядати ідентичність вашого користувача в Slack',
          heading: 'Переглянути інформацію про особистість користувача',
        },
        permissionNotifications: {
          extraInfo:
            'Vault зможе надсилати вам сповіщення у ваш обліковий запис Slack щодо будь-яких оновлень відправленого звіту або питання.',
          heading: 'Надсилати вам сповіщення',
        },
        permissionOverview: {
          extraInfo:
            'Vault відобразить огляд усіх подань на домашній сторінці.',
          heading: 'Огляд подань',
        },
        permissionSubmitReport: {
          extraInfo:
            'Це надасть Vault дозвіл відправляти звіт або ставити питання безпосередньо до вашої організації з Slack',
          heading: 'Надіслати звіт або питання від вашого імені',
        },
        successfulConnectionDescription:
          'Ваш обліковий запис Vault та обліковий запис Slack тепер підключені. Ви тепер можете закрити цю вкладку та повернутися до Slack.',
        successfulConnectionHeading: 'Успішно підключено',
        unsuccessfulConnectionDescription:
          'Щось пішло не так. Будь ласка, закрийте цю вкладку та поверніться в Slack, щоб спробувати знову.',
        unsuccessfulConnectionHeading: "Помилка з'єднання",
      },
      ReportingForgotPassword: {
        description:
          "Введіть адресу електронної пошти, яка пов'язана з вашим обліковим записом, і ми надішлемо вам посилання для скидання вашого пароля.",
        heading: 'Забута пароль',
        invalidTokenError: 'Не можу створити пароль, недійсний токен.',
        passwordReuseError: 'Повторення паролю не дозволено',
        passwordReuseErrorDescription:
          'Для вашої безпеки, ви не можете використовувати жоден з останніх шести паролів. Будь ласка, виберіть новий, унікальний пароль, щоб забезпечити безпеку вашого облікового запису та спробуйте знову.',
        sendLink: 'Відправити посилання для скидання',
        sendLinkFailure: 'Щось пішло не так',
        sendLinkFailureDescription:
          'Поверніться до <a>Центру Репортера</a> та спробуйте знову. Якщо проблема продовжується, зверніться до нас за адресою <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Посилання для скидання паролю відправлено',
        sendLinkSuccessDescription:
          'Ми відправили посилання для скидання паролю на {{email}}',
        updatePasswordSuccess: 'Пароль оновлено',
        updatePasswordSuccessDescription:
          'Ваш пароль успішно оновлено. Дякуємо, що ви зробили цей крок, щоб тримати ваші дані в безпеці!',
      },
      ReportingLogin: {
        accountFrozen: 'Обліковий запис заморожений',
        accountLocked:
          'Вхід було спробовано занадто багато разів неправильно. Обліковий запис заблоковано на термін до 1 години. Скидання пароля неможливе протягом цього часу.',
        accountLockedPermanently:
          'Ваш обліковий запис було заблоковано. Використовуйте скидання пароля, щоб повторно отримати доступ, або зверніться до системного адміністратора для подальшої допомоги.',
        createAccountCTA: 'Зареєструйте обліковий запис',
        currentPassword: 'Поточний пароль',
        emailLabel: 'Ваш Email',
        forgotPassword: 'Забули свій пароль?',
        loginButton: 'Увійти',
        newPasswordPlaceholder: 'Новий пароль',
        passwordFailMessage:
          'Поверніться до додатку Vault в Slack та спробуйте знову. Якщо проблема продовжується, зверніться до нас за адресою techsupport@vaultplatform.com',
        passwordFailTitle: 'Щось пішло не так',
        passwordLabel: 'Ваш пароль',
        passwordPlaceholder: 'Введіть свій пароль',
        passwordResetRequired: 'Необхідно скинути пароль',
        passwordSuccessfullySetMessage:
          'Поверніться до додатку Vault в Slack та авторизуйтеся за допомогою вашого нового пароля, щоб продовжити з того місця, де ви залишились.',
        passwordSuccessfullySetTitle: 'Пароль успішно встановлено',
        reenterPlaceholder: 'Повторіть пароль',
        title: 'Репортер Хаб',
        tooltip:
          'Якщо ви ще не встановили пароль для додатку Vault, перейдіть за цим посиланням, щоб розпочати. Якщо ви забули свій пароль, скористайтеся посиланням "Забули пароль" нижче.',
        usernameLoginFailed:
          "Вхід не вдалося, ім'я користувача або пароль невірні",
      },
      ReportingReset: {
        failureDescription:
          'Поверніться до додатку Vault у Slack і спробуйте знову. Якщо проблема продовжується, зверніться до нас за адресою <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Щось пішло не так',
        successDescription:
          'Поверніться до додатку Vault в Slack і авторизуйтеся за допомогою вашого нового пароля, щоб продовжити з того місця, де ви зупинились.',
        successHeading: 'Пароль успішно встановлено',
      },
      noReports: {
        description:
          'Всі подані звіти будуть відображатися тут. Дізнайтеся більше про способи, якими ви можете подати звіт в',
        descriptionHelpArticle: 'ця стаття допомоги',
        errorDescription:
          'Ми маємо проблеми з завантаженням ваших звітів. Будь ласка, спробуйте оновити сторінку.',
        errorDescriptionSecondary:
          'Якщо це не спрацює, будь ласка, зверніться до нас за адресою',
        errorTitle: '⚠️ Ой, щось пішло не так',
        title: 'У вас ще немає звітів',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Увімкніть автопереклад та читайте всі повідомлення звіту на вашій бажаній мові. Перекладена мова базується на мові, вибраній на вашому пристрої.',
          autoTranslationDescription2:
            'Ви можете переключатися між перекладеною та оригінальною мовою в кожному чаті.',
          autoTranslationTitle:
            'Увімкніть автоматичний переклад для повідомлень у звіті',
          header: 'Налаштування повідомлень',
          subHeader: 'Налаштуйте відображення повідомлень',
        },
        notificationSettings: {
          emailDescription:
            'Отримуйте сповіщення на електронну пошту про важливі оновлення ваших звітів',
          emailTitle: 'Електронні повідомлення',
          header: 'Налаштування сповіщень',
          subHeader: 'Налаштуйте, як ви отримуєте сповіщення',
        },
        title: 'Налаштування',
        updatedSettingsFailure: 'Не вдалося оновити ваші налаштування',
        updatedSettingsSuccess: 'Успішно оновлено ваші налаштування',
      },
    },
    validators: {
      passwordLength: 'Пароль повинен містити щонайменше 9 символів',
      passwordLowercase: 'Пароль повинен містити принаймні 1 малу літеру',
      passwordMissMatch: 'Поля пароля та підтвердження повинні збігатися.',
      passwordNumeric: 'Пароль повинен містити принаймні 1 цифру',
      passwordUppercase: 'Пароль повинен містити принаймні 1 велику літеру',
    },
    validatorsNew: {
      passwordLength: 'Між 10 та 30 символами',
      passwordLowercase: 'Принаймні одна мала літера',
      passwordMissMatch: 'Паролі не збігаються',
      passwordNumeric: 'Принаймні одне число',
      passwordSpecialCharacter: 'Принаймні один спеціальний символ',
      passwordUppercase: 'Принаймні одна велика літера',
    },
  },
};

export default translations;
